import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-module-disabled',
  templateUrl: './message-module-disabled.component.html',
})
export class MessageModuleDisabledComponent implements OnInit {
  @Input() message = 'Módulo no disponible';
  @Input() subMessage = 'Puede volver a intentarlo más tarde';
  @Input() icon = 'lock';

  constructor() {}

  ngOnInit() {}
}
